import React from 'react';
import CustomControl from '../../../../components/CustomControl/CustomControl';
import { Row, Col, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';

export default class OfferFlowsTableSettings extends React.Component {
    state = {
        checkbox: this.props.settings
    }

    toggleCheckbox = (key) => this.setState({ checkbox: { ...this.state.checkbox, [key]: !this.state.checkbox[key] } })

    handleSelectAll = () => {
        const { checkbox } = this.state;
        let upd = {};
        Object.keys(checkbox).map(key => {
            upd = { ...upd, [key]: true };
        })
        this.setState({ checkbox: upd })
    }

    handleRemoveSelections = () => {
        const { checkbox } = this.state;
        let upd = {};
        Object.keys(checkbox).map((key, id) => {
            id === 0 ? upd = { ...upd, [key]: true } : upd = { ...upd, [key]: false };
        })
        this.setState({ checkbox: upd })
    }

    renderCheckboxes = () => {
        const { checkbox } = this.state;
        return Object.keys(checkbox).map(key => {
            return (
                <Col key={key} lg='3' md='3' sm='6' xs='6'>
                    <CustomControl
                        id={`flows-table-${key}`}
                        className="custom-control-xs no-margin"
                        label={<FormattedMessage id={`table.settings.${key}`} defaultMessage={`${key}`} />}
                        onChange={() => {
                            this.toggleCheckbox(key)
                        }}
                        checked={checkbox[key]}
                        inline
                    />
                </Col>
            )
        })
    }

    render() {
        const { editSettings } = this.props;
        const { checkbox } = this.state;
        return <Row>
            {this.renderCheckboxes()}
            <Col lg='12' className='mt-4'>
                <Button className='float-right ml-2 mt-2' color='primary' size="sm" onClick={() => editSettings(checkbox)}>
                    <FormattedMessage id="main.apply" defaultMessage='Apply' />
                </Button>
                <Button outline className='float-right ml-2 mt-2' color='primary' size="sm" onClick={this.handleSelectAll}>
                    <FormattedMessage id="main.selectAll" defaultMessage='Select all' />
                </Button>
                <Button outline className='float-right ml-2 mt-2' color='primary' size="sm" onClick={this.handleRemoveSelections}>
                    <FormattedMessage id="main.removeSelections" defaultMessage='Remove selections' />
                </Button>
            </Col>
        </Row>
    }
}